module.exports = __webpack_public_path__ + "0bf6e6e3063d4754cfe3481faf1d195b.svg";